export enum ClaimStatusEnum {
  Created               = '00000079-1000-0000-0000-000000000001',
  PendingReview         = '00000079-1000-0000-0000-000000000002',
  ReviewedReadyToSend   = '00000079-1000-0000-0000-000000000003',
  Sending               = '00000079-1000-0000-0000-000000000004',
  SendError             = '00000079-1000-0000-0000-000000000005',
  Sent                  = '00000079-1000-0000-0000-000000000006',
  Closed                = '00000079-1000-0000-0000-000000000007',
  Canceled              = '00000079-1000-0000-0000-000000000008',
}
